import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class EdgestateConnectionRepositoryService extends BaseRepositoryService<
  ModelRegistry['edgestate-connection']
> {
  recordName = 'edgestate-connection';
  implementMethods = ['findAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/edgestate-connection': EdgestateConnectionRepositoryService;
  }
}
